// extracted by css-extract-rspack-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_L27","cls2":"ChurnedUserReactivationButton-cls2_lK6 ChurnedUserReactivationButton-cls1_L27"};